/**
 * Constants for smrt-projects package
 */

/**
 * Default sync throttle duration in milliseconds (5 minutes)
 * Prevents excessive API calls by skipping sync if synced recently
 */
export const SYNC_THROTTLE_MS = 5 * 60 * 1000;
